export enum CUSTOMER_BACK_OFFICE {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7244413
     */
    CUSTOMER_SETTINGS = 'ADMIN.NAV.CUSTOMER_SETTINGS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7244417
     */
    GLOBAL_ADMINS = 'ADMIN.NAV.SUPER_ADMINS',
}
